import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { Category } from "types/be/generated";

import { Flex, Text } from "src/components";
import { FontSize, FontWeight } from "src/theme";
import { CATEGORY_TITLE } from "../constants";

type TooltipContentProps = {
    category: Category;
    active: boolean;
};

export const TooltipContent: FC<TooltipContentProps> = ({ category, active }) => {
    const { t } = useTranslation();

    if (active) {
        return (
            <Flex>
                <Text size={FontSize._14} weight={FontWeight._700}>
                    {t("outage.cancel")}&nbsp;
                </Text>
                <Text size={FontSize._14}>{t("outage.filterType")}</Text>
            </Flex>
        );
    }

    return (
        <Flex>
            <Text size={FontSize._14} weight={FontWeight._700}>
                {t("outage.show")}&nbsp;
            </Text>
            <Text size={FontSize._14}>{t("outage.onlyOutageType")}&nbsp;</Text>
            <Text size={FontSize._14} weight={FontWeight._700}>
                {t(CATEGORY_TITLE[category])}
            </Text>
        </Flex>
    );
};
